<template>
  <div class="d-flex justify-content-center p-lg-12 p-7 h-100">
    <div class="bg-body d-flex flex-center rounded-4 p-lg-10 p-5 w-100">
      <div class="d-flex flex-center align-items-center w-md-400px">
        <div class="d-flex flex-center flex-column flex-column-fluid pb-15 pb-lg-20">
         <div class="form w-100">
           <div class="text-center mb-11">
             <h1 class="text-gray-900 fw-bolder mb-3">
               Вход
             </h1>
             <small v-if="message" class="text-danger">{{ message }}</small>
           </div>
           <div class="fv-row mb-3 d-flex">
             <div @click="changeFlag" class="d-flex h-50px p-4 bg-light me-2 rounded border" :class="verifyToken ? 'opacity-75 cursor-not-allowed' : 'cursor-pointer'">
               <img class="" height="25" :src="this.flag === 1 ? require('@/assets/images/uz.svg') : require('@/assets/images/kz.svg')" alt="">
             </div>
             <div class="w-100">
               <input-mask-field
                 v-model="auth.phone"
                 id="auth.phone"
                 name="auth.phone"
                 :disabled="this.loading || verifyToken"
                 :required="true"
                 :mb="3"
                 placeholder="Номер телефона"
                 :mask="mask"
                 type="text"
               />
             </div>
           </div>
           <div v-if="verifyToken" class="fv-row">
             <input-mask-field
               v-model="auth.code"
               id="auth.phone"
               name="auth.phone"
               :disabled="this.loading"
               :required="true"
               :mb="5"
               placeholder="Код"
               mask="######"
               type="text"
             />
           </div>
           <div v-if="authType" class="fv-row">
             <input-field
               v-model="auth.password"
               id="auth.password"
               name="auth.password"
               :required="true"
               placeholder="Пароль"
               type="password"
               mb="5"
             />
           </div>
           <span v-if="!verifyToken" @click="authType = !authType" class="text-success cursor-pointer ms-2 mb-5 d-inline-block">{{ authType ? 'Войти по СМС' : 'Войти по паролю' }}</span>
           <div class="d-grid">
             <button v-if="!verifyToken && !authType" type="button" @click="sendOtp" :disabled="auth.phone.length < (flag === 1 ? 15 : 17) || loading" class="btn btn-primary w-100">
               <span class="indicator-label">{{ !loading ? 'Отправить код' : 'Отправка...' }}</span>
             </button>
             <button v-if="(!verifyToken && authType) || (verifyToken && !authType)" type="button" @click="login" :disabled="((auth.phone.length < flag === 1 ? 15 : 17) && authType ? auth.password.length < 6 : auth.code.length < 6) || loading" class="btn btn-primary">
               <span class="indicator-label">{{ !loading ? 'Войти' : 'Проверка...' }}</span>
             </button>
           </div>
         </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputField from '@/components/Fields/InputField'
import InputMaskField from '@/components/Fields/InputMaskField'
import crypto from '@/helpers/crypto'
import axios  from 'axios'

export default {
  name: 'Login',
  components: {InputField, InputMaskField},
  data() {
    return {
      auth: {
        phone: '+998-',
        code: '',
        password: ''
      },
      authType: true,
      verifyToken: null,
      loading: false,
      message: null,
      flag: 1,
      mask: '+998-##-#######',
    }
  },
  methods: {
    changeFlag() {
      if (!this.verifyToken) {
        if (this.flag === 1) {
          this.flag = 2
          this.mask = '+7(###) ### ##-##'
          this.url  = 'kz'
          this.auth.phone = '+7'
        } else {
          this.flag = 1
          this.mask = '+998-##-#######'
          this.auth.phone = '+998-'
        }
      }
    },
    sendOtp() {
      this.loading = true
      axios.post(
        '/api/v1/security/mfa/otp/send',
        {
          clientId: this.authType ? 'order-service' : 'energo-admin',
          clientSecret: 'secret',
          username: this.auth.phone.replace(/\D/g, ''),
        },
        {
          headers: {
            'Accept': 'application/json',
            'Accept-Language': 'uz-UZ',
            'Content-Type': 'application/json'
          }
        })
        .then(res => {
          if (res.data.hasOwnProperty('verifyToken')) {
            this.verifyToken = res.data.verifyToken;
          } else {
            this.message = res.data.errorDescription;
          }
        })
        .catch(err => {
          if (err.response?.data?.errorDescription) {
            this.message = err.response.data.errorDescription;
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    login() {
      this.loading = true
      let params = {
        clientId: this.authType ? 'order-service' : 'energo-admin',
        clientSecret: 'secret',
        grantType: this.authType ? 'password' : 'http://auth0.com/oauth/grant-type/mfa-otp',
      }
      if (this.authType) {
        params['username'] = this.auth.phone.replace(/\D/g, '')
        params['password'] = this.auth.password
      } else {
        params['verifyToken'] = this.verifyToken
        params['code'] = this.auth.code
      }
      axios.post(
        '/api/v1/security/token',
        params,
        {
          headers: {'Accept': 'application/json', 'Accept-Language': 'uz-UZ', 'Content-Type': 'application/json'}
        })
        .then(res => {
          if (res.data.accessToken) {
            localStorage.setItem('access', crypto.encrypt(res.data.accessToken))
            localStorage.setItem('phone', this.auth.phone)
            window.location.href = '/'
          } else {
            this.message = res.data.errorDescription;
          }
        })
        .catch(err => {
          if (err.response?.data?.errorDescription) {
            this.message = err.response.data.errorDescription;
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
  watch:{
    auth: {
      deep: true,
      handler: function(newValue) {
        this.message = ''
      },
    }
  }
}
</script>

<style scoped>

</style>